// Shared phone helpers — mirror backend routes/clients._validate_phone.
export const sanitizePhoneInput = (raw) => (raw || "").replace(/[^\d+\s.\-()]/g, "");

export const normalizePhone = (raw) => {
  let d = (raw || "").replace(/[^\d+]/g, "");
  if (d.startsWith("+33")) d = "0" + d.slice(3);
  else if (d.startsWith("0033")) d = "0" + d.slice(4);
  return d.replace(/[^\d]/g, "");
};

// wa.me expects international digits only: 06… → 336…, +44… → 44…, 0044… → 44…
export const toWhatsAppNumber = (raw) => {
  const d = (raw || "").replace(/[^\d+]/g, "");
  if (d.startsWith("+")) return d.slice(1).replace(/\D/g, "");
  if (d.startsWith("00")) return d.slice(2);
  if (d.length === 10 && d.startsWith("0")) return "33" + d.slice(1);
  return d;
};

export const whatsAppLink = (phone, text = "") =>
  `https://wa.me/${toWhatsAppNumber(phone)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const phoneError = (raw) => {
  if (!raw) return "";
  if (/[a-zA-Z]/.test(raw)) return "Les lettres ne sont pas autorisées";
  const n = normalizePhone(raw);
  if (n.length < 10) return `10 chiffres minimum (actuellement ${n.length})`;
  if (n.length > 15) return "Numéro trop long";
  return "";
};
